import React, { useLayoutEffect } from 'react';

import { AuthEndpoint } from '@datarock/api-client';
import FullscreenLoader from '../../components/FullscreenLoader';
import { IndexPath } from '../../routing';
import { useAuth } from 'oidc-react';
import { useHistory } from 'react-router-dom';

/**
 * Completes OIDC RP-initiated logout: IdP redirects here with query params.
 * Must run `signoutRedirectCallback` so oidc-client-ts clears storage; otherwise
 * AuthProvider may treat `session_state` / `state` as a sign-in callback and hang.
 */
export default function SignOutCallback() {
  const auth = useAuth();
  const history = useHistory();

  useLayoutEffect(() => {
    let cancelled = false;

    void (async () => {
      try {
        await auth.userManager.signoutRedirectCallback();
      } catch {
        // Still send user to app root; session is often already cleared server-side.
      }
      AuthEndpoint.accessToken = undefined;
      if (!cancelled) {
        history.replace(IndexPath);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [auth.userManager, history]);

  return <FullscreenLoader />;
}
